// extracted by mini-css-extract-plugin
export default {"the_process":"TheProcess_the_process__yj+ED"};